import { BsInstagram } from 'react-icons/bs';
import { AiOutlineMail, AiOutlineGithub } from 'react-icons/ai';
import { images } from '../../constants';
export const linksData = [
  {
    name: 'Github',
    link: 'https://github.com/varunnaik1121',
    icon: images.github,
  },
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/varunnaik62/',
    icon: images.instagram,
  },
  {
    name: 'Mail',
    link: 'mailto:varunnaik1121@gmail.com',
    icon: images.mail,
  },
];
